import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useOtp } from "../../Contexts/OtpContext";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import {
  WEBSERVICE,
  OPTIONS_FOR_FINGERPRINT,
  showToast,
  handleSendOtpInSms,
  handleDefaultAssetPair,
} from "../../CoreDataService";
import Fingerprint2 from "fingerprintjs2";
import Cookies from "js-cookie";
import CloseIcon from "@mui/icons-material/Close";

import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Link,
  CircularProgress,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";
import { faTruckField } from "@fortawesome/free-solid-svg-icons";
// No TypeScript global declaration needed in JS files

const SocialLogin = ({ purpose }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loginResponse, setLoginResponse] = useState(null);
  const [smsOtp, setSmsOtp] = useState("");
  const [twoFactorOtp, setTwoFactorOtp] = useState("");
  const [isPhoneVerificationEnable, setIsPhoneVerificationEnable] =
    useState(false);
  const [isGoogleAuthEnable, setIsGoogleAuthEnable] = useState(false);
  const [authOtpModalShow, setAuthOtpModalShow] = useState(false);
  const handleAuthOtpModalClose = () => (
    setAuthOtpModalShow(false), setPhoneOtp(""), setGaOtp("")
  );
  var [gaOtp, setGaOtp] = useState("");
  var [phoneOtp, setPhoneOtp] = useState("");
  const [copyPhoneEmail, setCopyPhoneEmail] = useState("");
  const [countdown, setCountdown] = useState(300);

  var [socalMediaIdRes, setSocalMediaIdRes] = useState("");
  var [socialAccessTokenRes, setSocialAccessTokenRes] = useState("");
  var [socialMediaTypeRes, setSocialMediaTypeRes] = useState("");

  const containerRef = useRef(null);
  const [googleBtnWidth, setGoogleBtnWidth] = useState("200");

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const width = containerRef.current.clientWidth;
        if (window.innerWidth <= 576 && width > 0) {
          const clamped = Math.min(Math.max(Math.floor(width), 200), 400);
          setGoogleBtnWidth(`${clamped}`);
        } else {
          setGoogleBtnWidth("200");
        }
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const GOOGLE_CLIENT_ID =
    "745537630536-mpu63dt7rsdcia6jece33jlvavkls3g2.apps.googleusercontent.com";
  const [isLoading, setIsLoading] = useState(false);
  const facebookIconImageLink =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAclBMVEU6VZ/////p7PR8jLzz9fkwTpySn8czUJ2ElMItTJs7WKOpss+msNAnSJnK0eT6+v2Xps3f4+9cca5KY6fU2upSaalDXaVme7SKmcScqMvP1OTj5vDs7/XGzeIiRZhZca+1vtqxutW+x+B2h7mAjrxugLacEYxHAAADBklEQVR4nO3baXLiMBBAYQdsFDkGwr4MJEAy97/iMPmdOLJUortV7x3Apa8Mkhe5qoiIiIiIiIiIiIiIiIiI1Oecaxrfm5MeY3TOT5vtZvexP3S97Y0SfbM8HBeLP6NTPe/t6TyVHmtE/u29W9Tzp6Bm5oSuWnanMJxJoWt3lwE8e0K3G3T+zAn9/e830GdL6J/Xg32mhO516A/UltC1L4HLg1GhW52jfGaEbjd8ijEldMtRLNCG0K1iJlFLwvYWDzQhdC8JQAtCP6nLFjYf8bOMCaHbzJKA+oXVPg2oX7hJWChMCN0kEaheuI26nzAk9F0qULuwTQYqFzapE6l64fRYunCVdL1mQNjs4x5c2BH62CcXZoSb6EcXRoTuOXm5v3dULPTdgL9hfbwcXr9rrPj9oQ9+B1PPxtXU++a7FAOrJnSiWY9VO36uDbz3va0a6aFGtgq7orlsbZ7A+1T6HnTzO9tYBQY+yT99mAVWLugh27WVHmd8bhwgHBk+hWHC40Z6mAkFCW9WF4r/BQlfvPQwEwoR1ofSz2E9Qag5hAj1hxCh/hAi1B9ChPpDiFB/CBHqDyFCJbmf80FC33OEr4R9y+ef++x+3xE1v3z2HOEr2XdTPuk7g7Bkf8YPENZvpQvXshuGHiC8yL6ceoDwtfj/ofCmrwcIl8ULV6LABwhP29KFa1ngA4S34oVd8cJJ8ULpTWH5hbvShSfhBT+/cC29sS+78Cx8SZNfeBW+pMkvPAgD8wsn0juIsws/SxeO/pYuXOyEgdmF8l+b5BbepJfD7EL5z01yCzvxnfyZhXP5d2+ZhSfx5TC3cCG+HOYWrqXvDrMLZ+KLRW7hWdp3F16zCm/ii0VVtT2F7cVwPUeQ1v1WE7YXQ3qYCRWyn6YnhAj1hxCh/hAi1B9ChPpDiFB/CBHqDyFC/SFEqD+ECPWHEKH+ECLUH0KE+kOIUH8IEeoPIUL9IUSoP4QI9YcQof4QItQfQoT6Q4hQfwgR6g8hQv0hRKg/hAj1hxCh/hAi1B9ChAP6B1ndUcZ6wYWaAAAAAElFTkSuQmCC";
  const IPGEO_API_KEY = "693da481af1b4a3e80e3dfea9115dc52";

  const LINKEDINREDIRECTURI = "https://trade.paybito.com/";
  const LINKEDINCLIENTID = "86n39gg96l3mq3";
  const LINKEDINSECRETID = "LaMhjR4SJckFyg1M";
  const [showGetCodeButtonInSmsOtpPopup, setShowGetCodeButtonInSmsOtpPopup] =
    useState(300);
  var [userPhoneUsingForSendingSms, setUserPhoneUsingForSendingSms] =
    useState("");
  var [
    userPhoneCountryCodeUsingForSendingSms,
    setUserPhoneCountryCodeUsingForSendingSms,
  ] = useState("");

  const currentDate = new Date();
  const endTimeRef = useRef(Date.now());
  const timerRef = useRef(null);
  const phoneOtpEndTimeRef = useRef(Date.now());
  const phonetimerRef = useRef(null);

  // console.log("showCounter", countdown);

  useEffect(() => {
    // Clean up localStorage on component mount
    localStorage.removeItem("facebook_app_id");
    localStorage.removeItem("google_app_id");
    localStorage.setItem("isForceReload", "true");
    localStorage.setItem("purpose", purpose);

    // Initialize Facebook SDK
    initializeFacebookSDK();

    return () => {
      // Cleanup if needed
    };
  }, [purpose]);

  // Check for LinkedIn callback code in URL on component mount
  useEffect(() => {
    const linkedInCode = searchParams.get("code");
    const state = searchParams.get("state"); // Optional: verify state for security

    if (linkedInCode) {
      console.log("LinkedIn authorization code found:", linkedInCode);
      handleLinkedInAccessToken(linkedInCode);

      // Optional: Clean up URL after processing
      // navigate(window.location.pathname, { replace: true });
    }
  }, [searchParams]);

  useEffect(() => {
    handleSendOtpThroughSms();
  }, [userPhoneUsingForSendingSms, userPhoneCountryCodeUsingForSendingSms]);

  const { sendSmartMobileOtp } = useOtp();

  const handleSendOtpThroughSms = async () => {
    // disabledSpan = true;
    console.log("sms func");

    if (userPhoneUsingForSendingSms) {
      console.log("calling sms func");

      let payload = {
        phone: userPhoneUsingForSendingSms,
        countryCode: userPhoneCountryCodeUsingForSendingSms,
      };
      
      try {
        await sendSmartMobileOtp(payload, "login");
        startPhoneOtpCountdown();
      } catch (error) {
        console.error("Social Login SMS OTP Error:", error);
      }
    }
  };

  const startPhoneOtpCountdown = () => {
    // Clear any existing interval
    if (phonetimerRef.current) clearInterval(phonetimerRef.current);

    // Set end time to 5 minutes (300 sec) from now
    phoneOtpEndTimeRef.current = Date.now() + 300 * 1000;

    const updateCountdown = () => {
      const remaining = Math.max(
        Math.floor((phoneOtpEndTimeRef.current - Date.now()) / 1000),
        0
      );
      setShowGetCodeButtonInSmsOtpPopup(remaining);

      if (remaining === 0 && phonetimerRef.current) {
        clearInterval(phonetimerRef.current);
      }
    };

    // Run immediately
    updateCountdown();

    // Run every second
    phonetimerRef.current = setInterval(updateCountdown, 1000);
  };

  const handleLinkedInAccessToken = async (code) => {
    console.log("LinkedIn login data", code);
    document.body.classList.add("overlay");
    // setLoading(true);

    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getLinkedInData/web`,
        {
          params: { code },
          responseType: "text",
        }
      );

      const data = response.data;
      let res;

      // Parse the response
      try {
        res = typeof data === "string" ? JSON.parse(data) : data;
      } catch (parseError) {
        console.error("Error parsing LinkedIn response:", parseError);
        throw new Error("Invalid response from LinkedIn");
      }

      console.log("LinkedIn response:", res);

      // Check for error status codes in the response
      const errorCodes = ["400", "401", "403", "404", "500"];
      const hasError = errorCodes.some(
        (code) => data.toString().indexOf(code) !== -1
      );

      if (!hasError && res && res.id) {
        // Store LinkedIn user data
        localStorage.setItem("linkedin_app_id", res.id);
        localStorage.setItem("linkedin_email", res.email || "");
        localStorage.setItem(
          "linkedin_name",
          `${res.firstName || ""} ${res.lastName || ""}`.trim()
        );
        localStorage.setItem("socialLoginType", "linkedin");

        console.log("LinkedIn Token:", res.linkedinToken);

        // Proceed with MFA check or login
        await handleCheckMf(
          localStorage.getItem("linkedin_app_id"),
          res.linkedinToken,
          "LinkedIn"
        );
      } else {
        document.body.classList.remove("overlay");
        showToast("danger", "Unable to retrieve data from LinkedIn");
      }
    } catch (error) {
      console.error("LinkedIn authentication error:", error);
      document.body.classList.remove("overlay");
      showToast("danger", "LinkedIn authentication failed");
    } finally {
      // setLoading(false);
      document.body.classList.remove("overlay");
    }
  };

  const initializeFacebookSDK = () => {
    // Initialize Facebook SDK
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "1387722119182461",
        cookie: false,
        xfbml: true,
        version: "v2.10",
      });
      window.FB.AppEvents.logPageView();
    };

    // Load Facebook SDK script
    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      if (fjs && fjs.parentNode) {
        fjs.parentNode.insertBefore(js, fjs);
      }
    })(document, "script", "facebook-jssdk");
  };

  const loginWithFacebook = () => {
    setIsLoading(true);

    if (!window.FB) {
      console.error("Facebook SDK not loaded");
      setIsLoading(false);
      return;
    }

    window.FB.getLoginStatus(function (response) {
      console.log(response);

      if (response.status === "connected") {
        // Already logged in
        handleSuccessfulLogin(response.authResponse.accessToken);
      } else {
        // Need to login
        window.FB.login((loginResponse) => {
          console.log("FB login response", loginResponse);

          if (
            loginResponse.status === "connected" &&
            loginResponse.authResponse
          ) {
            handleSuccessfulLogin(loginResponse.authResponse.accessToken);
          } else {
            console.log("User login failed or cancelled");
            setIsLoading(false);
          }
        });
      }
    }, true);
  };

  const loginWithLinkedIn = () => {
    const clientId = LINKEDINCLIENTID;
    const redirectUri = encodeURIComponent(LINKEDINREDIRECTURI);
    const state = "DCEeFWf45A53sdfKef424"; // you might want to generate this dynamically in a real app

    const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&state=${state}&scope=r_emailaddress%20r_liteprofile&redirect_uri=${redirectUri}`;

    // Redirect the user
    window.location.href = url;
  };

  const handleSuccessfulLogin = (accessToken) => {
    console.log("Facebook access token:", accessToken);

    // Store tokens in localStorage
    localStorage.setItem("facebookAccessToken", accessToken);
    localStorage.setItem("isCallAccountDetails", "true");

    // Call your account details function
    getAccountDetails();
    setIsLoading(false);
  };

  // const getAccountDetails = async () => {
  //   try {
  //     // Your account details API call here
  //     console.log('Getting account details...');

  //     // After getting account details, trigger login API
  //     localStorage.setItem('isCallLoginApi', 'true');
  //     localStorage.setItem('socialLoginType', 'facebook');

  //     const facebookAppId = localStorage.getItem('facebook_app_id');
  //     const facebookAccessToken = localStorage.getItem('facebookAccessToken');

  //     if (facebookAppId && facebookAccessToken) {
  //       await handleCheckMf(facebookAppId, facebookAccessToken, 'Facebook');
  //     }
  //   } catch (error) {
  //     console.error('Error getting account details:', error);
  //     setIsLoading(false);
  //   }
  // };

  const getAccountDetails = () => {
    if (!window.FB) {
      console.error("Facebook SDK not loaded");
      setIsLoading(false);
      return;
    }

    window.FB.api("/me", { fields: "id,email,name" }, function (response) {
      if (response && !response.error) {
        console.log(
          "Good to see you, " +
            response.name +
            ". Email: " +
            response.email +
            " Facebook ID: " +
            response.id
        );

        localStorage.setItem("facebook_name", response.name);
        localStorage.setItem("facebook_email", response.email);
        localStorage.setItem("facebook_app_id", response.id);

        // You can retrieve any purpose stored earlier if needed
        const purpose = localStorage.getItem("purpose");
        console.log("purpose =>", purpose);

        localStorage.setItem("isCallLoginApi", "true");
        localStorage.setItem("socialLoginType", "facebook");

        // Optionally call another API handler here
        handleCheckMf(
          response.id,
          localStorage.getItem("facebookAccessToken"),
          "Facebook"
        );
      } else {
        console.error("Error fetching account details:", response.error);
      }
      setIsLoading(false);
    });
  };

  useEffect(() => {
    // Initialize as in your Angular component
    localStorage.removeItem("facebook_app_id");
    localStorage.removeItem("google_app_id");
    localStorage.setItem("isForceReload", "true");
    localStorage.setItem("purpose", purpose);
  }, [purpose]);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      console.log("Google Login Success:", decoded);

      // Store user data in localStorage as in your Angular implementation
      localStorage.setItem("google_app_id", decoded.sub);
      localStorage.setItem("google_name", decoded.name);
      localStorage.setItem("google_email", decoded.email);
      localStorage.setItem("google_image", decoded.picture);
      localStorage.setItem("socialLoginType", "google");

      // Call checkMfaStatus with the same parameters
      await handleCheckMf(decoded.sub, credentialResponse.credential, "Google");
    } catch (error) {
      console.error("Error handling Google login:", error);
    }
  };

  const handleCheckMf = async (
    socialMediaId,
    socialAccessToken,
    socialMediaType
  ) => {
    try {
      setSocalMediaIdRes(socialMediaId);
      setSocialAccessTokenRes(socialAccessToken);
      setSocialMediaTypeRes(socialMediaType);

      const payload = {
        socialMediaId,
        loginType: 2,
        socialMediaType,
        brokerId: localStorage.getItem("BROKERID_Domain"),
      };

      const response = await axios.post(
        `${WEBSERVICE}user/checkMfaStatus`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      const data = response.data;

      if (data.error?.error_data === 1) {
        // Show error message
        alert(data.error.error_msg);
      } else if (data.error?.error_data === 2) {
        navigate("/social-signup");
      } else if (data.error?.error_data === 0) {
        // Store user auth data
        localStorage.setItem("twoFactorAuth", data.userResult?.twoFactorAuth);
        localStorage.setItem(
          "userSmsAuthStatus",
          data.userResult?.phoneValidation
        );

        setUserPhoneUsingForSendingSms(data?.userResult?.phone);
        setUserPhoneCountryCodeUsingForSendingSms(
          data?.userResult?.countryCode
        );

        var phone2fa = data.userResult?.phoneValidation === 1;
        var goo2fa = data.userResult?.twoFactorAuth === 1;

        setIsPhoneVerificationEnable(phone2fa);
        setIsGoogleAuthEnable(goo2fa);

        if (
          data.userResult?.phoneValidation ||
          data.userResult?.twoFactorAuth
        ) {
          setAuthOtpModalShow(true);
        } else {
          await handleLoginAPICall(
            socialMediaId,
            socialAccessToken,
            socialMediaType
          );
        }
      } else {
        // Show OTP input
        console.log("Show OTP input");
        // You might set state to show an OTP input component
      }
    } catch (error) {
      console.error("Error in checkMfaStatus:", error);
    }
  };

  // Helper function to detect device type
  const getDeviceInfo = () => {
    const userAgent = navigator.userAgent;
    const isMobile = /Mobile|Android|iPhone/i.test(userAgent);
    const isTablet = /iPad|Tablet/i.test(userAgent);
    const isDesktop = !isMobile && !isTablet;

    // Get browser info
    let browserName = "Unknown";
    let browserVersion = "";

    if (userAgent.indexOf("Chrome") > -1) {
      browserName = "Chrome";
      browserVersion = userAgent.match(/Chrome\/(\d+)/)?.[1] || "";
    } else if (userAgent.indexOf("Safari") > -1) {
      browserName = "Safari";
      browserVersion = userAgent.match(/Version\/(\d+)/)?.[1] || "";
    } else if (userAgent.indexOf("Firefox") > -1) {
      browserName = "Firefox";
      browserVersion = userAgent.match(/Firefox\/(\d+)/)?.[1] || "";
    }

    return {
      deviceType: isMobile ? "mobile" : isTablet ? "tablet" : "Desktop browser",
      browser: `${browserName}${browserVersion}`,
    };
  };

  const generateUUID = () => {
    Fingerprint2.get(OPTIONS_FOR_FINGERPRINT, (components) => {
      const values = components.map((component) => component.value);
      const hash = Fingerprint2.x64hash128(values.join(""), 31);
      const existingDeviceId = localStorage.getItem("deviceId");

      if (
        !existingDeviceId ||
        existingDeviceId === "null" ||
        existingDeviceId === "undefined" ||
        existingDeviceId === ""
      ) {
        localStorage.setItem("deviceId", hash);
        Cookies.set("deviceID", hash, { expires: 60 }); // 60 days
      }

      console.log("Device ID:", hash);
      return hash;
    });
  };

  const routeToLocation = () => {
    // Implement your routing logic here
    navigate("/spot");
  };

  // Function to handle page reload
  const handlePageReloadForcibly = (delay) => {
    setTimeout(() => {
      window.location.reload();
    }, delay);
  };

  const setLoginData = async (data) => {
    const userId = data.userResult.userId;
    localStorage.setItem("access_token", data.token);
    localStorage.setItem("uuid", data.userResult.uuid);

    // Prepare user object for getting user details
    const userObj = {
      userId: userId,
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/GetUserDetails`,
        userObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      document.body.classList.remove("overlay");

      if (response.data.error.error_data === 0) {
        const userResult = response.data.userResult;
        const expiryDate = new Date();
        expiryDate.setMonth(expiryDate.getMonth() + 12);

        // Set cookies
        Cookies.set("Username", userResult.firstName, {
          expires: expiryDate,
          domain: ".paybito.com",
          path: "/",
        });
        Cookies.set("userId", userResult.userId, {
          expires: expiryDate,
          domain: ".paybito.com",
          path: "/",
        });
        Cookies.set("access_token", localStorage.getItem("access_token"), {
          expires: 60,
        });
        Cookies.set("ssecca", localStorage.getItem("access_token"), {
          expires: expiryDate,
          domain: ".paybito.com",
          path: "/",
        });

        // Set localStorage items
        localStorage.setItem("user_name", userResult.firstName);
        localStorage.setItem("first_name", userResult.firstName);
        localStorage.setItem("last_name", userResult.lastName);
        localStorage.setItem("middle_name", userResult.middleName);
        localStorage.setItem("user_id", userResult.userId);
        localStorage.setItem("userId", userResult.userId);
        localStorage.setItem("email", userResult.email);
        localStorage.setItem("profile_pic", userResult.profilePic);
        localStorage.setItem("check_id_verification_status", "true");
        const pair = response.data?.defaultAssetPair || response.data?.userResult?.defaultAssetPair;
        if (pair) {
          handleDefaultAssetPair(pair, true);
        } else {
          localStorage.setItem("selected_currency", "btc");
          localStorage.setItem("buying_crypto_asset", "btc");
          localStorage.setItem("selling_crypto_asset", "usdt");
        }
        localStorage.setItem("UserTiretype", userResult.userTierType);
        localStorage.setItem("exist2FaKey", userResult.exist2FaKey);
        localStorage.setItem("parentId", userResult.parentId);
        localStorage.setItem("isFiatDeposit", userResult.isFiatDeposit);
        localStorage.setItem("isFiatWithdraw", userResult.isFiatWithdraw);

        // Store asset management permissions if parent ID exists
        if (userResult.parentId != null) {
          const permissions = {
            convert: userResult.convert,
            otc: userResult.otc,
            spot: userResult.spot,
            futures: userResult.futures,
            options: userResult.options,
            copyTrade: userResult.copyTrade,
            payments: userResult.payments,
            ico: userResult.ico,
          };
          localStorage.setItem(
            "permission_for_asset_management",
            JSON.stringify(permissions)
          );
        }

        localStorage.setItem("BROKERID", userResult.brokerId);
        localStorage.setItem("isUserLoggedInThroughSocial", "true");

        // Get broker details
        // await getAllBrokerDetails();

        // Handle routing based on different conditions
        const sixthParam = localStorage.getItem("sixthParam");
        const basicRoute = sessionStorage.getItem("basicroute");
        const otcRoute = sessionStorage.getItem("otcroute");
        const proDashboard = sessionStorage.getItem("proDashboard");

        if (sixthParam === "nft") {
          const obj = {
            userId: localStorage.getItem("user_id"),
            uuid: localStorage.getItem("uuid"),
            token: localStorage.getItem("access_token"),
          };
          const str = btoa(JSON.stringify(obj));
          localStorage.removeItem("sixthParam");
          window.location.href = `https://www.paybito.com/nft-marketplace/session/${str}`;
        } else if (sixthParam === "data-deletion") {
          navigate("/settings");
        } else if (basicRoute === "basic") {
          navigate("/basic");
          handlePageReloadForcibly(100);
        } else if (otcRoute === "otc") {
          navigate("/otc");
          handlePageReloadForcibly(100);
        } else if (proDashboard === "pro") {
          routeToLocation();
        } else {
          if (userResult.userTierType === 2 || userResult.userTierType === 3) {
            routeToLocation();
          } else {
            navigate("/identity-verification");
            handlePageReloadForcibly(100);
          }
        }

        // Close any open modals (implement based on your modal library)
        // modalService.dismissAll();

        showToast("success", "Login Successful!");
        // countdown();
      }
    } catch (error) {
      showToast("danger", error.message || "An error occurred");
    }
  };

  const handleLoginAPICall = async (
    socialMediaId,
    socialMediaToken,
    socialMediaType
  ) => {
    document.body.classList.add("overlay");
    // setLoading(true);

    try {
      // Get geolocation data
      const geoResponse = await axios.get(
        `https://api.ipgeolocation.io/ipgeo?apiKey=${IPGEO_API_KEY}`
      );

      const {
        latitude,
        longitude,
        ip: ipAddress,
        country_name: location,
      } = geoResponse.data;

      // Store geolocation data
      localStorage.setItem("latitude", latitude);
      localStorage.setItem("longitude", longitude);
      localStorage.setItem("ipaddress", ipAddress);
      localStorage.setItem("location", location);

      // Get device info
      const { deviceType, browser } = getDeviceInfo();

      // Get or generate device ID
      let deviceId = Cookies.get("deviceID");
      if (!deviceId || deviceId === "undefined") {
        deviceId = generateUUID();
        Cookies.set("deviceID", deviceId, { expires: 60 });
      }
      localStorage.setItem("deviceid", deviceId);

      // Prepare login object
      const loginObj = {
        latitude,
        longitude,
        ipAddress,
        location,
        callFrom: "web",
        browser,
        deviceId,
        deviceType,
        socialMediaId,
        loginType: 2,
        socialMediaToken,
        socialMediaType,
      };

      // Add OTP fields if enabled
      if (isPhoneVerificationEnable) {
        loginObj.phoneOtp = phoneOtp;
      }
      if (isGoogleAuthEnable) {
        loginObj.securityCode = gaOtp;
      }
      loginObj.brokerId = localStorage.getItem("BROKERID_Domain");

      // Make login API call
      const loginResponse = await axios.post(
        `${WEBSERVICE}user/LoginWithUsernamePassword`,
        loginObj,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Close modal (implement based on your modal library)
      // modalService.dismissAll();

      const errorData = loginResponse.data.error.error_data;

      if (errorData === 1) {
        showToast("error", loginResponse.data.error.error_msg);
        // If login type > 0, navigate to social signup
        // navigate('/social-signup');
        document.body.classList.remove("overlay");
      } else if (errorData === 0) {
        setLoginResponse(loginResponse.data);
        await setLoginData(loginResponse.data);
      } else {
        // Handle OTP verification case
        // Show OTP segment (implement based on your UI)
        console.log("OTP verification required");
        // You can set state to show OTP input UI
      }
    } catch (error) {
      console.error("Login error:", error);
      showToast("error", "An error occurred during login");
    } finally {
      // setLoading(false);
      document.body.classList.remove("overlay");
    }
  };

  return (
    <>
      <div className="social-login-container" ref={containerRef}>
        {/* Facebook Login Row */}
        <div className="social-btn-row">
          <button
            type="button"
            className="social-btn"
            onClick={loginWithFacebook}
            disabled={isLoading}
          >
            <span className="social-icon-wrapper">
              <img
                src={facebookIconImageLink}
                alt="facebook"
                className="icon-image"
              />
            </span>
            <span className="socialText">Sign in with Facebook</span>
          </button>
        </div>

        {/* Google Login Row */}
        <div className="social-btn-row google-btn-row">
          <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <div className="google-login-wrapper">
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => console.log("Google Login Failed")}
                useOneTap={false}
                theme="outline"
                size="large"
                text="signin_with"
                shape="rectangular"
                width={googleBtnWidth}
              />
            </div>
          </GoogleOAuthProvider>
        </div>

        {/* LinkedIn Login Row */}
        <div className="social-btn-row">
          <button
            type="button"
            className="social-btn"
            onClick={loginWithLinkedIn}
            disabled={isLoading}
          >
            <span className="social-icon-wrapper">
              <i className="fa fa-linkedin-square linkdIn" aria-hidden="true"></i>
            </span>
            <span className="socialText">Sign in with LinkedIn</span>
          </button>
        </div>

        <style>{`
        .social-login-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-top: 20px;
          width: 100%;
          box-sizing: border-box;
        }

        .social-btn-row {
          flex: 1 1 0px;
          min-width: 0;
          display: flex;
          justify-content: center;
        }

        .social-btn-row.google-btn-row {
          flex: 0 0 200px;
          width: 200px;
          min-width: 200px;
          max-width: 200px;
        }

        .social-btn {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 40px;
          border: 1px solid #dadce0;
          border-radius: 4px;
          background: #ffffff;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          font-size: 12px;
          font-weight: 500;
          color: #3c4043;
          cursor: pointer;
          transition: all 0.2s ease;
          padding: 0 6px 0 28px;
          box-sizing: border-box;
          white-space: nowrap;
        }

        .social-btn:hover:not(:disabled) {
          background: #f8f9fa;
          border-color: #c1c7cd;
          box-shadow: 0 1px 3px rgba(60, 64, 67, 0.15);
        }

        .social-btn:active:not(:disabled) {
          transform: translateY(0);
          background: #f1f3f4;
        }

        .social-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .social-icon-wrapper {
          position: absolute;
          left: 8px;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
        }

        .socialText {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
          width: 100%;
        }

        .icon-image {
          width: 18px;
          height: 18px;
          object-fit: contain;
        }

        .linkdIn {
          font-size: 18px;
          color: #0A66C2;
        }

        .google-login-wrapper {
          width: 200px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .google-login-wrapper > div {
          display: flex !important;
          justify-content: center !important;
          width: 200px !important;
        }

        @media (max-width: 576px) {
          .social-login-container {
            flex-direction: column;
            gap: 12px;
            margin-top: 18px;
            width: 100%;
          }

          .social-btn-row {
            flex: none;
            width: 100%;
            max-width: 100%;
          }

          .social-btn-row.google-btn-row {
            flex: none;
            width: 100%;
            max-width: 100%;
          }

          .social-btn {
            width: 100%;
            height: 40px;
            font-size: 14px;
            padding: 0 36px;
            border-radius: 4px;
          }

          .social-icon-wrapper {
            left: 14px;
            width: 20px;
            height: 20px;
          }

          .icon-image {
            width: 18px;
            height: 18px;
          }

          .linkdIn {
            font-size: 20px;
          }

          .google-login-wrapper {
            width: 100%;
            height: 40px;
          }

          .google-login-wrapper > div {
            width: 100% !important;
          }
        }
      `}</style>
      </div>

      <Dialog
        open={authOtpModalShow}
        onClose={handleAuthOtpModalClose}
        maxWidth="xs"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 3,
            backgroundColor: "#fff",
            color: "#000",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff",
            color: "#000",
          }}
        >
          <span>Security Authentication</span>
          <IconButton onClick={() => setAuthOtpModalShow(false)}>
            <CloseIcon sx={{ color: "#1976d2" }} />
          </IconButton>
        </DialogTitle>

        {/* <button className="close-button" onClick={handleAuthOtpModalClose}>
              <span className="close-icon-wallet">&times;</span>
            </button> */}

        <DialogContent>
          <Box>
            {isPhoneVerificationEnable && (
              <>
                <Typography sx={{ pt: 1, color: "black" }}>
                  Input OTP from your registered phone number
                </Typography>
                <TextField
                  fullWidth
                  type="text"
                  inputMode="numeric"
                  autoComplete="off"
                  label="Phone OTP"
                  variant="outlined"
                  margin="normal"
                  value={phoneOtp}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 8);
                    setPhoneOtp(value);
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "#333",
                      "&.Mui-focused": {
                        color: "#1976d2",
                      },
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      mt: 0.5,
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {showGetCodeButtonInSmsOtpPopup === 0 && (
                          <Typography
                            variant="body2"
                            sx={{
                              cursor: "pointer",
                              color: "primary.main",
                              whiteSpace: "nowrap",
                            }}
                            onClick={handleSendOtpThroughSms}
                          >
                            Get code
                          </Typography>
                        )}
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    mt: 2,
                    input: { color: "#333" },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      "& fieldset": {
                        borderColor: "#ccc",
                      },
                      "&:hover fieldset": {
                        borderColor: "#888",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#1976d2",
                      },
                    },
                  }}
                />
                {showGetCodeButtonInSmsOtpPopup !== 0 && (
                  <Typography variant="body2" sx={{ color: "green", mb: 2 }}>
                    Resend in {showGetCodeButtonInSmsOtpPopup} seconds
                  </Typography>
                )}
              </>
            )}

            {isGoogleAuthEnable && (
              <>
                <Typography sx={{ pt: 1, color: "black" }}>
                  Input OTP from your Google Authenticator
                </Typography>
                <TextField
                  fullWidth
                  type="text"
                  inputMode="numeric"
                  autoComplete="off"
                  label="Google Authenticator code"
                  variant="outlined"
                  margin="normal"
                  value={gaOtp}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setGaOtp(value);
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "#333",
                      "&.Mui-focused": {
                        color: "#1976d2",
                      },
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      mt: 0.5,
                    },
                  }}
                  sx={{
                    mt: 2,
                    input: { color: "#333" },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      "& fieldset": {
                        borderColor: "#ccc",
                      },
                      "&:hover fieldset": {
                        borderColor: "#888",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#1976d2",
                      },
                    },
                  }}
                />
              </>
            )}

            <Button
              type="submit"
              onClick={() =>
                handleLoginAPICall(
                  socalMediaIdRes,
                  socialAccessTokenRes,
                  socialMediaTypeRes
                )
              }
              variant="contained"
              fullWidth
              disabled={countdown === 0}
              className="primaryButton"
              sx={{
                mt: 3,
                color: "#fff",
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#ccc", // visible grey
                  color: "#666", // visible text color
                },
              }}
            >
              Confirm
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SocialLogin;
